module.exports = __webpack_public_path__ + "static/bg-wedding-cdb41a59f0ebe86cc56412450a87eed5.jpg";